// No reward-ads endpoints exist on the backend yet — this module ships as a
// static scaffold (matching the Payout page's convention) with generated
// mock data, ready to be swapped for real API calls once the contract exists.

const MONTH_LABELS = ['Jan 2024', 'Feb 2024', 'Mar 2024', 'Apr 2024', 'May 2024', 'Jun 2024', 'Jul 2024', 'Aug 2024', 'Sep 2024', 'Oct 2024', 'Nov 2024', 'Dec 2024']

function seededRandom(seed) {
  let value = seed
  return () => {
    value = (value * 9301 + 49297) % 233280
    return value / 233280
  }
}

function buildSeries(rand, base, variance) {
  return MONTH_LABELS.map((label) => ({
    label,
    value: Math.round(base + (rand() - 0.4) * variance)
  }))
}

function buildCampaign(index) {
  const rand = seededRandom(index * 97 + 13)
  const statuses = ['active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'active', 'scheduled', 'scheduled', 'scheduled', 'scheduled', 'completed', 'completed', 'completed', 'completed', 'completed', 'completed', 'completed', 'completed', 'completed', 'completed']
  const status = statuses[index % statuses.length]

  const budget = 150000
  const dailyBudget = 5000
  const spentPercent = status === 'completed' ? 100 : Math.round(20 + rand() * 60)
  const spent = Math.round((budget * spentPercent) / 100)

  const impressions = Math.round(100000 + rand() * 40000)
  const videoStarts = Math.round(impressions * 0.79)
  const viewsCompleted = Math.round(videoStarts * 0.6)
  const ctaClicks = Math.round(viewsCompleted * 0.072)
  const rewardClaims = Math.round(ctaClicks * 0.788)

  return {
    id: `RA-CAM-${String(1000 + index).padStart(5, '0')}`,
    title: 'Fuel Voucher Rewards',
    description: 'Offer NGN 500 fuel voucher for watching ads',
    ctaMessage: 'Watch ad to get NGN 500 for watching ads',
    callbackUrl: 'https://goil/callback/reward/fuel',
    merchant: 'GOIL Filling Station',
    status,
    thumbnailTone: ['primary', 'purple', 'success', 'gold'][index % 4],
    period: { start: '2025-05-20', end: '2026-06-20', label: 'May 15 - Jun 15 1016', daysLeft: 31 },
    budget,
    dailyBudget,
    spent,
    spentPercent,
    targeting: { audience: 'All Customers', age: '18+ years' },
    frequency: { perUser: 2, per: 'Day' },
    campaignId: `RA-CAM-${String(24 - index).padStart(5, '0')}`,
    createdAt: 'May 18, 2025, 10:14 AM',
    updatedAt: 'May 18, 2025, 10:14 AM',

    video: { name: 'RA-CAM-00024', format: 'MP4', duration: '15s', size: '4.2 MB' },

    targetSummary: {
      interests: 'Automotive, Fuel & Energy, Commuting',
      location: 'Lagos, Abuja, Port Harcourt, Ibadan',
      ipTargeting: 'All IPs (No restrictions)'
    },
    scheduleSummary: {
      startDate: 'May 20 2025',
      endDate: 'May 20 2025',
      daysToDisplay: '31 days',
      hoursToDisplay: '6:00 AM - 10:00 PM',
      frequency: '2 per user per day'
    },
    repeatSummary: {
      daysToRepeat: '0 days (Same day)',
      hoursToRepeat: '24 hours'
    },

    performance: {
      stats: [
        { key: 'impressions', label: 'Impressions', value: impressions.toLocaleString(), trend: 18.8, tone: 'purple' },
        { key: 'video_starts', label: 'Video Starts', value: videoStarts.toLocaleString(), trend: 12.8, tone: 'primary' },
        { key: 'view_completed', label: 'View (Completed)', value: viewsCompleted.toLocaleString(), trend: 21.4, tone: 'success' },
        { key: 'completion_rate', label: 'Completion Rate', value: '10', suffix: '%', trend: 21.4, tone: 'purple' },
        { key: 'cta_clicks', label: 'CTA Clicks', value: ctaClicks.toLocaleString(), trend: -4.4, tone: 'gold' },
        { key: 'reward_claims', label: 'Reward Claims', value: rewardClaims.toLocaleString(), trend: 12.8, tone: 'gold' },
        { key: 'spend', label: 'Spend', value: `GHS ${spent.toLocaleString()}.00`, trend: 12.8, tone: 'primary' },
        { key: 'cost_per_completed_view', label: 'Cost Per Completed View', value: 'GHS 0.04', trend: -4.4, tone: 'primary' }
      ],
      sourcingVsDemand: {
        series: [
          { key: 'impressions', label: 'Impressions', color: '#7C3AED', data: buildSeries(rand, 90000, 20000) },
          { key: 'video_starts', label: 'Video Starts', color: '#1976D2', data: buildSeries(rand, 70000, 15000) },
          { key: 'completed_views', label: 'Completed Views', color: '#34C759', data: buildSeries(rand, 50000, 12000) },
          { key: 'clicks', label: 'Clicks', color: '#DCA815', data: buildSeries(rand, 20000, 6000) },
          { key: 'claims', label: 'Claims', color: '#60A5FA', data: buildSeries(rand, 8000, 3000) }
        ]
      },
      funnel: [
        { key: 'impressions', label: 'Impressions', value: impressions, percent: 100, tone: 'purple' },
        { key: 'video_starts', label: 'Video Starts', value: videoStarts, percent: 78.8, tone: 'primary' },
        { key: 'completed_views', label: 'Completed Views', value: viewsCompleted, percent: 60, tone: 'success' },
        { key: 'cta_clicks', label: 'CTA Clicks', value: ctaClicks, percent: 7.2, tone: 'gold' },
        { key: 'reward_claims', label: 'Reward Claims', value: rewardClaims, percent: 5.1, tone: 'blue' }
      ],
      conversionRate: [
        { key: 'start_rate', label: 'Start Rate', formula: 'Video Starts / Impressions', value: 78.8, tone: 'primary' },
        { key: 'completion_to_click', label: 'Completion-to-Click', formula: 'Clicks / Completed Views', value: 78.8, tone: 'success' },
        { key: 'click_to_claim', label: 'Click-to-Claim', formula: 'Clicks / Completed Views', value: 78.8, tone: 'gold' },
        { key: 'view_to_claim', label: 'View-to-Claim', formula: 'Claim/Completed Views', value: 78.8, tone: 'blue' }
      ],
      spendEfficiency: [
        { key: 'cost_per_1000_impressions', label: 'Cost Per 1,000 Impressions', value: 'GHS 25.34', trend: 76, tone: 'primary' },
        { key: 'cost_per_completed_view', label: 'Cost Per Completed View', value: 'GHS 0.04', trend: 76, tone: 'success' },
        { key: 'cost_per_claim', label: 'Cost Per Claim', value: 'GHS 0.04', trend: 76, tone: 'primary' }
      ],
      videoMetrics: [
        { key: 'video_length', label: 'Video Length', value: '30s' },
        { key: 'avg_watch_time', label: 'Average Watch Time', value: '11.8s' },
        { key: 'drop_off_5s', label: 'Drop-off at 5s', value: '18%' },
        { key: 'drop_off_10s', label: 'Drop-off at 10s', value: '9%' },
        { key: 'asset_status', label: 'Asset Status', value: 'ACTIVE', tone: 'success' }
      ]
    },

    audience: {
      stats: [
        { key: 'reached_users', label: 'Reached Users', value: '74,234', trend: 8, tone: 'purple' },
        { key: 'unique_viewers', label: 'Unique Viewers', value: '52,323', trend: 13, tone: 'primary' },
        { key: 'repeat_viewers', label: 'Repeat Viewers', value: '18,987', trend: 2.4, tone: 'success' },
        { key: 'average_frequency', label: 'Average Frequency', value: '2.4', suffix: 'views/user', trend: 2.4, tone: 'purple' },
        { key: 'completed_viewers', label: 'Completed Viewers', value: '31,542', trend: -4.6, tone: 'success' },
        { key: 'reward_claims', label: 'Reward Claims', value: '6,312', trend: 10.6, tone: 'gold' }
      ],
      reachOverTime: {
        series: [
          { key: 'reached_users', label: 'Reached Users', color: '#7C3AED', data: buildSeries(rand, 90000, 20000) },
          { key: 'video_starts', label: 'Video Starts', color: '#1976D2', data: buildSeries(rand, 70000, 15000) },
          { key: 'completed_viewers', label: 'Completed Viewers', color: '#34C759', data: buildSeries(rand, 50000, 12000) }
        ]
      },
      viewerFrequencyDistribution: [
        { label: '1 View', percent: 30.2, color: '#60A5FA' },
        { label: '2 Viewers', percent: 29.8, color: '#1976D2' },
        { label: '3-5 Viewers', percent: 28.4, color: '#05213D' },
        { label: '5+ Viewers', percent: 11.6, color: '#34C759' }
      ],
      targetingSummary: {
        interests: 'Fuel & Energy, Drivers, Mobility',
        locations: 'Accra, Kumasi, Takoradi',
        ipTargeting: 'including 2 IP ranges',
        devices: 'mobile Only',
        estimatedReach: '85,000 - 11,000 users'
      },
      viewerTypeBreakdown: [
        { label: 'First-time Viewers', percent: 33, color: '#1976D2' },
        { label: 'Returning Viewers', percent: 41, color: '#34C759' },
        { label: 'Frequent Viewers', percent: 26, color: '#60A5FA' }
      ],
      audienceQuality: [
        { key: 'video_length', label: 'Video Length', value: '30s', tone: 'primary' },
        { key: 'claim_rate', label: 'Claim Rate', value: '8.4%', tone: 'gold' },
        { key: 'completion_rate', label: 'Completion Rate', value: '60.0%', tone: 'success' },
        { key: 'repeat_view_share', label: 'Repeat View Share', value: '36.5%', tone: 'purple' }
      ],
      engagementByCohort: [
        { cohort: 'First-time Viewers', uniqueViewers: '17,323', completionRate: '52.1%', ctaClickRate: '4.2%', rewardClaims: '1,234' },
        { cohort: 'Returning Viewers', uniqueViewers: '17,322', completionRate: '52.1%', ctaClickRate: '4.2%', rewardClaims: '1,234' },
        { cohort: 'Frequent Viewers', uniqueViewers: '17,323', completionRate: '52.1%', ctaClickRate: '4.2%', rewardClaims: '1,234' }
      ]
    },

    location: {
      stats: [
        { key: 'locations', label: 'Location', value: '4', tone: 'purple' },
        { key: 'top_city', label: 'Top City', value: 'Accra', tone: 'primary' },
        { key: 'top_city_views', label: 'Top City Views', value: '28,342', tone: 'purple' },
        { key: 'highest_completion_city', label: 'Highest Completion City', value: 'Accra', suffix: '64%', tone: 'primary' },
        { key: 'reward_claims_top_city', label: 'Reward Claims from Accra', value: '2,324', trend: 0, tone: 'gold' },
        { key: 'avg_cost_per_view', label: 'Avg Cost Per View', value: 'GHS 0.04', tone: 'danger' }
      ],
      viewByLocationOverTime: {
        series: [
          { key: 'accra', label: 'Accra', color: '#7C3AED', data: buildSeries(rand, 80000, 20000) },
          { key: 'kumasi', label: 'Kumasi', color: '#1976D2', data: buildSeries(rand, 55000, 15000) },
          { key: 'takoradi', label: 'Takoradi', color: '#34C759', data: buildSeries(rand, 35000, 10000) },
          { key: 'tamale', label: 'Tamale', color: '#DCA815', data: buildSeries(rand, 15000, 6000) },
          { key: 'other', label: 'Other', color: '#748799', data: buildSeries(rand, 8000, 3000) }
        ]
      },
      viewersByLocation: [
        { label: 'Accra', percent: 38.2, color: '#7C3AED' },
        { label: 'Kumasi', percent: 24, color: '#1976D2' },
        { label: 'Takoradi', percent: 13.3, color: '#34C759' },
        { label: 'Tamale', percent: 7.8, color: '#DCA815' },
        { label: 'Other', percent: 16.7, color: '#748799' }
      ],
      targetingSummary: {
        interests: 'Fuel & Energy, Drivers, Mobility',
        locations: 'Accra, Kumasi, Takoradi',
        ipTargeting: 'including 2 IP ranges',
        devices: 'mobile Only',
        estimatedReach: '85,000 - 11,000 users'
      },
      viewerTypeBreakdown: [
        { label: 'First-time Viewers', percent: 33, color: '#1976D2' },
        { label: 'Returning Viewers', percent: 41, color: '#34C759' },
        { label: 'Frequent Viewers', percent: 26, color: '#60A5FA' }
      ],
      audienceQuality: [
        { key: 'video_length', label: 'Video Length', value: '30s', tone: 'primary' },
        { key: 'claim_rate', label: 'Claim Rate', value: '8.4%', tone: 'gold' },
        { key: 'completion_rate', label: 'Completion Rate', value: '60.0%', tone: 'success' },
        { key: 'repeat_view_share', label: 'Repeat View Share', value: '36.5%', tone: 'purple' }
      ]
    },

    devices: {
      stats: [
        { key: 'device_types', label: 'Device Types', value: '2', tone: 'purple' },
        { key: 'top_device', label: 'Top Device', value: 'Mobile', tone: 'primary' },
        { key: 'top_device_share', label: 'Top Device Share', value: '86.4%', tone: 'success' },
        { key: 'top_os', label: 'Top OS', value: 'Android', tone: 'gold' },
        { key: 'avg_session_duration', label: 'Avg Session Duration', value: '42s', tone: 'primary' },
        { key: 'avg_cost_per_device_view', label: 'Avg Cost Per View', value: 'GHS 0.04', tone: 'danger' }
      ],
      deviceBreakdown: [
        { label: 'Mobile', percent: 86.4, color: '#7C3AED' },
        { label: 'Desktop', percent: 9.8, color: '#1976D2' },
        { label: 'Tablet', percent: 3.8, color: '#34C759' }
      ],
      osBreakdown: [
        { label: 'Android', percent: 61.2, color: '#34C759' },
        { label: 'iOS', percent: 33.6, color: '#748799' },
        { label: 'Other', percent: 5.2, color: '#DCA815' }
      ],
      deviceTable: [
        { device: 'Mobile', viewers: '45,231', completionRate: '61.2%', ctaClickRate: '7.4%', rewardClaims: '5,432' },
        { device: 'Desktop', viewers: '5,132', completionRate: '54.8%', ctaClickRate: '6.1%', rewardClaims: '621' },
        { device: 'Tablet', viewers: '1,960', completionRate: '49.3%', ctaClickRate: '5.6%', rewardClaims: '259' }
      ]
    }
  }
}

export const REWARD_ADS_TOTAL = 24
export const REWARD_ADS_ACTIVE = 10
export const REWARD_ADS_SCHEDULED = 4
export const REWARD_ADS_COMPLETED = 10

export function getMockCampaigns() {
  return Array.from({ length: REWARD_ADS_TOTAL }, (_, index) => buildCampaign(index))
}

export function getMockCampaignById(id) {
  return getMockCampaigns().find((campaign) => campaign.id === id) ?? buildCampaign(0)
}
